/**
 * For use to provide unique IDs to new repeated elements that can't use "id" as a key
 */
export function getRandomID(): string {
  return `temp_${Math.floor(Math.random() * 1e10)}`
}
